import React from "react";
import { Loader2 } from "lucide-react";
import { formatter } from "~/functions";

export function BalanceLine({ title, value, tone = "default", children = null }) {
  const toneClass =
    tone === "success"
      ? "text-emerald-600"
      : tone === "danger"
      ? "text-red-600"
      : "";
  return (
    <div className="flex flex-row items-center justify-between w-full gap-4">
      <span className={`text-gray-500 ${toneClass}`}>{title}</span>
      <div className="flex flex-row items-center justify-end gap-2">
        <span className={`font-bold ${toneClass}`}>
          {formatter.format(Number(value || 0))}
        </span>
        {children}
      </div>
    </div>
  );
}

export function BalanceBox({ loading = false, children }) {
  if (loading) {
    return (
      <div className="w-full border rounded-xl p-4 flex flex-row items-center justify-center gap-2 text-xs text-gray-500">
        <Loader2 size={16} className="animate-spin" /> Loading balance...
      </div>
    );
  }
  return (
    <div className="w-full border rounded-xl p-4 flex flex-col items-start justify-start gap-2 text-xs">
      {children}
    </div>
  );
}
